import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideCheckCheck = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 6 7 17l-5-5m20-2-7.5 7.5L13 16"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideCheckCheck);
const Memo = memo(ForwardRef);
export default Memo;
